import { Trans, useTranslation } from 'react-i18next';

import { Box, Heading, Text } from '@chakra-ui/react';

import { ButtonLink } from '~/components/button-link';
import { Link } from '~/components/link';
import { useCourseLink } from '~/features/program/hooks/use-course-link';

export type MarketingMessageProps = {
  programTitle?: string | null;
  programSlug?: string | null;
};

export function MarketingMessage({ programTitle, programSlug }: MarketingMessageProps) {
  const { t } = useTranslation();
  const courseLink = useCourseLink({ courseSlug: programSlug ?? '' });
  return (
    <>
      <Box mb='16px'>
        <Heading as='h1' mb='8px' size='marketing-4xl'>
          {t('certificate.developJobReadySkills')}
        </Heading>
        <Text>{t('certificate.upskillOrReskill')}</Text>
      </Box>
      <ButtonLink
        buttonProps={{
          mb: '40px',
          id: 'browse-catalog-link',
        }}
        linkProps={{
          href: '/catalog',
        }}
      >
        {t('certificate.browseUdacityCatalog')}
      </ButtonLink>
      {programTitle && programSlug && (
        <Text>
          <Trans i18nKey='certificate.interestedInProgram' values={{ programTitle }}>
            <strong>Interested in the program?</strong> Explore
            <Link href={courseLink} id='view-details-link'>
              {programTitle}
            </Link>
          </Trans>
        </Text>
      )}
    </>
  );
}
